export const EDUCATION_TYPE = {
  PRESENCIAL: {
    id: '019a837a-57f7-7061-a219-fde25210cea4',
    label: 'Presencial'
  },
  EAD: {
    id: '019a837a-2540-7158-ad7a-05c34840d7f8',
    label: 'EAD'
  }
}
